var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#E9EBF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9277 22.9805C22.9277 23.3848 22.6055 23.707 22.2012 23.707H7.70117C7.29688 23.707 6.97461 23.3848 6.97461 22.9805C6.97461 22.9805 7.0957 20.4766 9.07422 19.5078C10.3262 18.9023 9.8418 19.1855 11.377 18.5781C12.9121 17.9707 13.2754 17.5273 13.2754 17.5273L13.1953 16.7188C13.1953 16.7188 11.498 16.2344 11.2168 14.377C10.6914 14.498 10.5293 13.8105 10.4902 13.3672C10.4492 12.9238 10.168 11.5488 10.8125 11.6699C10.6914 10.7402 10.5703 9.93359 10.6504 9.48828C10.7305 8.76172 10.5293 8.64062 11.2168 8.07422C11.3789 7.91211 11.0547 7.22656 11.1758 7.02344C11.377 6.61914 12.75 6.78125 12.9531 6.70117C13.5195 6.45898 14.1641 6.29688 14.8516 6.25781C17.7598 6.37891 18.8906 7.95508 19.0527 9.48828C19.0938 9.93164 19.0117 10.7402 18.8516 11.6699C19.498 11.5488 19.2148 12.9219 19.1738 13.3672C19.1328 13.8105 18.9727 14.5391 18.4473 14.377C18.1641 16.2344 16.791 16.7188 16.791 16.7188L16.7109 17.4863C16.7109 17.4863 17.0742 17.8906 18.6094 18.5371C20.1445 19.1426 19.6602 18.9004 20.9121 19.5059C22.8066 20.4375 22.9277 22.9805 22.9277 22.9805Z",
    fill: "#CECECE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e1b5362da541880da2903e6437170338.svg";
export { ForwardRef as ReactComponent };